<app-loading [type]="'spinner'" [showLoading]="showLoading"></app-loading>
<form [formGroup]="commentsOccurrenceForm" class="comments-container">
  <h2 class="title">comentários</h2>
  <mat-form-field>
    <textarea
      id="occurrence-add-comments"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows=5
      cdkAutosizeMaxRows=7
      #autosize="cdkTextareaAutosize"
      formControlName="comments"
      maxlength="1500">
    </textarea>
    <mat-hint align="end">{{ 1500 - commentsOccurrenceForm.controls['comments'].value?.length }} caracteres restantes.</mat-hint>
  </mat-form-field>
  <div class="flex-container justify-end">
    <div class="atachments-upload">
      <div *ngIf="filesToUpload && filesToUpload.length > 0" class="iterable-atach-comments ">
        <div *ngFor="let file of filesToUpload; let i = index" class="file-data">
          <div>
            <p [matTooltip]="file.name">{{file.nameSimplyfied ? file.nameSimplyfied : file.name}}</p>
            <p>{{file.textSize}}</p>
          </div>
          <p (click)="removeAtachment(i)" class="file-data-remove">X</p>
        </div>
      </div>
    </div>
    <input #uploadFile
      type="file"
      id="uploadFile"
      class="visibility-hidden no-width"
      (change)="handleFileInput($event)"
      (click)="$event.target.value = null"
    />
    <button href="javascript:void(0);" class="cursor-pointer text-right mt-10 no-border no-background no-padding" (click)="uploadFile.click()" title="Anexar Arquivo" alt="Anexar Arquivo">
      <img width="25px" [matTooltip]="'Anexar Arquivo'" src="./assets/img/attach.svg" />
    </button>
    <button href="javascript:void(0);" class="cursor-pointer text-right mt-10 no-border no-background no-padding" [disabled]="commentsOccurrenceForm.controls['comments'].value?.length === 0" (click)="clearComment()" title="Limpar" alt="Limpar">
      <img width="25px" [matTooltip]="'Limpar'" src="{{ commentsOccurrenceForm.controls['comments'].value?.length > 0 ? './assets/img/trash.svg' : './assets/img/trash_disabled.svg' }}"  />
    </button>
    <button href="javascript:void(0);" class="cursor-pointer text-right mt-10 no-border no-background no-padding" [disabled]="!commentsOccurrenceForm.valid" (click)="onSubmit()" title="Enviar comentário" alt="Enviar comentário">
      <img width="25px" [matTooltip]="'Enviar comentário'" src="{{ commentsOccurrenceForm.valid ? './assets/img/send.svg' : './assets/img/send_disabled.svg' }}" />
    </button>
  </div>
</form>
